export default __webpack_public_path__ + "static/media/logo.cef4c8b2.png";